import {
  DOC_TYPE,
  STATUS,
  VerificationResponse,
} from '../components/DriverVerification/type.ts';
import Api from './Api.ts';

export const getAllDriver = async () => {
  const response = await Api.get('/super-admin/drivers');
  return response.data;
};

export const getAllVerifiedDriver = async (page = 1, limit = 10) => {
  try {
    const response = await Api.get(`/super-admin/drivers/verified?page=${page}&limit=${limit}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching support requests:', error);
    throw error;
  }
};

export const deleteDriver = async (id: any) => {
  const response = await Api.delete(`/super-admin/drivers/${id}`);
  return response.data;
};

export const getAllVehicles = async () => {
  const response = await Api.get(`/super-admin/vehicles`);
  return response.data;
};

export const getAllActiveDrivers = async () => {
  const response = await Api.get(
    `/super-admin/drivers_with_location?isActive=true`
  );
  return response.data;
};

export const deleteActiveDrivers = async (id: string | number) => {
  try {
    const response = await Api.put(`/super-admin/drivers/${id}/status`, {
      status: 'FREE',
      isActive: false,
    });
    return response.data;
  } catch (error) {
    console.error(`Error deactivating driver with ID ${id}:`, error);
    throw error;
  }
};

export const updateDriverStatus = async (id: string | number) => {
  try {
    const response = await Api.put(`/super-admin/drivers/${id}/status`, {
      status: 'FREE',
      isActive: true,
    });
    return response.data;
  } catch (error) {
    console.error(`Error deactivating driver with ID ${id}:`, error);
    throw error;
  }
};

export const getDriversToVerify = async (page: number = 1, limit: number = 10000) => {
  const response = await Api.get(`/super-admin/drivers/unverified?page=${page}&limit=${limit}`);
  return response.data;
};

export const getDriverDetails = async (driverId: number) => {
  const response = await Api.get(`super-admin/drivers/${driverId}`);
  return response.data;
};

export const verifyDriverDocument = async (
  driverId: number,
  document_type: DOC_TYPE,
  status: STATUS,
  rejection_message: string
) => {
  try {
    const response = await Api.patch(`driver-verification/${driverId}/status`, {
      document_type,
      status,
      rejection_message,
    });
    return (
      (response.data as VerificationResponse)?.data?.status === STATUS.VERIFIED
    );
  } catch {
    alert('Something Went Wrong, Try Again');
  } finally {
    return false;
  }
};

export const createDriver = async (driverData: any) => {
  const response = await Api.post('/super-admin/drivers', driverData);
  return response.data;
};

export const updateDriver = async (id: number, driverData: any) => {
  const response = await Api.put(`/super-admin/drivers/${id}`, driverData);
  return response.data;
};



